<template>
    <div class="vue-wp-admin-settings">
      <!-- Image Generation -->
      <ImageGeneration v-if="this.customFields.image_generation"/>
      <!-- <h2>Detecting inputs..</h2> -->
      <!-- <TinyMCEHandler
        @show-popup="openPopup"
        @close-popup="closePopup"
        v-if="this.customFields.on_selection"
      /> -->
      <!-- if page url contains /wp-admin/post.php -->
      <GutenbergHandler
        @show-popup="openPopup"
        @close-popup="closePopup"
        v-if="this.customFields.gutenberg_enabled"
      />
      <TextInputHandler
        @show-popup="openPopup"
        @close-popup="closePopup"
        :selection="selection"
        @update-selection="updateSelection"
        :customFields="customFields"
      />
      <SmartPressPopup 
        v-if="showPopup"
        :selectedText="selectedText"
        :position="popupPosition"
        :inputType="inputType"
        :targetElement="targetElement"
        @close="closePopup"
        @append-content="handleAppendContent"
        @replace-content="handleReplaceContent"
      />
    </div>
  </template>
  
  <script>
  import SmartPressPopup from './SmartPressPopup.vue';
  // import TinyMCEHandler from './TinyMCEHandler.vue';
  import TextInputHandler from './TextInputHandler.vue';
  import GutenbergHandler from './GutenbergHandler.vue';
  import ImageGeneration from './smart-press/ImageGeneration.vue';
  export default {
    name: 'detectInputs',
    components: {
      SmartPressPopup,
      // TinyMCEHandler,
      TextInputHandler,
      GutenbergHandler,
      ImageGeneration
    },
    props: {
      customFields: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        client: null,
        account: null,
        functions: null,
        showPopup: false,
        selectedText: '',
        popupPosition: { top: 0, left: 0 },
        inputType: 'text',
        targetElement: null,
        selection: ''
      }
    },
    methods: {
      isTinyMCEEditor(element) {
        return typeof window.tinymce !== 'undefined' && 
               window.tinymce.Editor && 
               element instanceof window.tinymce.Editor;
      },
      openPopup(selectedText, rect, iframeRect, element, type) {
        console.log('openPopup', selectedText, rect, iframeRect, element);
        this.selectedText = selectedText;
        this.targetElement = element;
       
        // Get viewport dimensions (visible area only)
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = document.documentElement.clientHeight;
        
        // Popup dimensions
        const popupWidth = 500;
        const popupHeight = 400;
        
        // Calculate initial position (preferring right side of selection/input)
        const selectionRight = rect.right;
        const selectionLeft = rect.left;
        
        // Try to position to the right of the selection/button first
        let leftPosition = selectionRight + 10; // 10px gap
        
        // If popup would go outside right edge, try positioning to the left
        if (leftPosition + popupWidth > viewportWidth) {
          leftPosition = selectionLeft - popupWidth - 10; // 10px gap
          
          // If that would push it outside left edge, align with left viewport edge
          if (leftPosition < 0) {
            leftPosition = 20; // 20px margin from left
          }
        }
        
        // Calculate vertical position
        let topPosition = rect.top;
        
        // Handle vertical positioning for different input types
        this.inputType = this.isTinyMCEEditor(element) ? 'html' : 'text';
        if(type){
          this.inputType = type;
        }
        
        if (this.inputType === 'text' || this.isTinyMCEEditor(element)) {
          // For text inputs or TinyMCE, align with the top of the input/button
          if (window.location.href.includes('post.php')) {
            topPosition += 100;
          }
        }
        
        // Ensure popup stays within vertical viewport
        if (topPosition + popupHeight > viewportHeight) {
          topPosition = Math.max(20, viewportHeight - popupHeight - 20);
        }
        
        // Ensure minimum margins
        topPosition = Math.max(20, topPosition);
        leftPosition = Math.max(20, leftPosition);
        
        this.popupPosition = { 
          top: topPosition + window.scrollY,
          left: leftPosition
        };
        
        this.showPopup = true;
      },
      
      closePopup() {
        this.showPopup = false;
      },

      handleAppendContent(generatedContent) {
        if (!this.targetElement) return;

        if (this.isTinyMCEEditor(this.targetElement)) {
          // Handle TinyMCE editor
          const editor = this.targetElement;
          const currentContent = editor.getContent();
          editor.setContent(currentContent + generatedContent);
        } else if (this.targetElement instanceof HTMLElement) {
          // Handle regular input/textarea elements
          const element = this.targetElement;
          if (element.value !== undefined) {
            const currentValue = element.value;
            element.value = currentValue + generatedContent;
            
            // Trigger input event for reactivity
            element.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      },

      handleReplaceContent(generatedContent) {
        if (!this.targetElement) return;

        if (this.isTinyMCEEditor(this.targetElement)) {
          // Handle TinyMCE editor
          const editor = this.targetElement;
          if (this.selectedText) {
            // Replace selected text
            editor.selection.setContent(generatedContent);
          } else {
            // Replace entire content
            editor.setContent(generatedContent);
          }
        } else if (this.targetElement instanceof HTMLElement) {
          // Handle regular input/textarea elements
          const element = this.targetElement;
          if (element.value !== undefined) {
            if (this.selectedText && this.selectedText != element.value) {
              // Replace selected text
              const start = element.selectionStart;
              const end = element.selectionEnd;
              const currentValue = element.value;
              element.value = currentValue.substring(0, start) + 
                             generatedContent + 
                             currentValue.substring(end);
            } else {
              // Replace entire content
              element.value = generatedContent;
            }
            
            // Trigger input event for reactivity
            element.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      },
      updateSelection(newSelection) {
      this.selection = newSelection;
      }
    },
    mounted() {
      
    }
   
  }
  </script>
  
  <style scoped>
  
  </style> 